import { render } from "./ViewDTRGeneratorDialog.vue?vue&type=template&id=36ad5a4c&scoped=true"
import script from "./ViewDTRGeneratorDialog.vue?vue&type=script&lang=js"
export * from "./ViewDTRGeneratorDialog.vue?vue&type=script&lang=js"

import "./ViewDTRGeneratorDialog.vue?vue&type=style&index=0&id=36ad5a4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ad5a4c"]])

export default __exports__